/**
 * External Imports
 */
import { FC, useCallback } from 'react';
import { connect } from 'react-redux';

/**
 * Internal Imports
 */
import SupportListSettingsTable from './supportListSettingsTable/SupportListSettingsTable';
import { RootState } from '../../../../redux/store';
import {
  useGetEmployeeSubjectConfigQuery,
  useUpdateSubjectHiddenStatusMutation
} from '../../../../redux/apis/Users.api';

import { useFeatures } from '../../../../services/Features/features';
import { useUserRolesRef } from '../../../../services/UserRoles';

/**
 * GLobal Type Definition Imports
 */
import { ValidationEmployee } from '../../../../config/interfaces';

interface NLRListSettingsProps {
  facilityId: string;
  userId: string;
}

const NLRListSettingsTable: FC<NLRListSettingsProps> = ({
  facilityId,
  userId
}) => {
  const {
    isEnterpriseAdmin,
    isNonSupportRounder,
    isTemplateConfigurator,
    isUserAdmin,
    isValidationRounder
  } = useUserRolesRef();

  const { isNLRValidationEnabled } = useFeatures();

  const {
    data: nlrValidationEmployeeData,
    // isError: isGetEmployeeConfigError,
    // isFetching: isGetEmployeeConfigFetching,
    isLoading: isGetEmployeeConfigLoading
  } = useGetEmployeeSubjectConfigQuery(
    // Need to adjust later when we know new validation rounding types
    { employeeId: userId, roundingType: 'validation' },
    {
      refetchOnMountOrArgChange: 15,
      skip: !isNLRValidationEnabled || !userId
    }
  );
  const [
    updateSubjectHiddenStatus
    // {
    //   isError: isUpdateSubjectHiddenStatusError,
    //   isLoading: isUpdateSubjectHiddenStatusLoading,
    //   isSuccess: isUpdateSubjectHiddenStatusSuccess
    // }
  ] = useUpdateSubjectHiddenStatusMutation();

  const hideEmployee = useCallback(
    (employee: ValidationEmployee) => {
      updateSubjectHiddenStatus({
        employeeId: employee.hcaid,
        facilityId,
        roundingType: 'validation',
        userId,
        visible: !employee.visible
      });
    },
    [facilityId, userId]
  );

  return (
    <SupportListSettingsTable
      employees={nlrValidationEmployeeData}
      isFacilitySelectorEnabled={
        isEnterpriseAdmin ||
        (isValidationRounder &&
          !(isNonSupportRounder || isTemplateConfigurator || isUserAdmin))
      }
      isTableEnabled={isNLRValidationEnabled}
      loadingSupportList={isGetEmployeeConfigLoading}
      type="nlr"
      hideEmployee={hideEmployee}
    />
  );
};

const mapReduxStateToProps = (state: RootState) => {
  return {
    facilityId: state.AuthorizedUser.authorizedUser.facilityId,
    userId: state.AuthorizedUser.authorizedUser.hcaid
  };
};

export default connect(mapReduxStateToProps)(NLRListSettingsTable);
